import {StyleSheet} from "aphrodite";

import type {StyleType} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Title} from "@khanacademy/wonder-blocks-typography";

type Props = {
    children: any;
    style?: StyleType;
    tag?: string;
};

function AuthTitle(props: Props) {
    const {children, style, tag} = props;

    return (
        <Title style={[styles.header, style]} tag={tag}>
            {children}
        </Title>
    );
}

const styles = StyleSheet.create({
    header: {
        marginBottom: spacing.xxxSmall_4,
        fontSize: 44,
        lineHeight: "48px",
        fontWeight: "normal",
        fontFamily: "'Source Serif Pro', 'Noto Serif', serif",
    },
});

export default AuthTitle;
